(ns minorodata.notifications.model
  (:require [mold.core :as m :refer-macros [defmodel]]))


(declare ->notification
         ->account-notifications)


(defmodel notification
  {:preference-id        [::m/string ::m/identity]
   :source               [::m/string "Transform/Extract master ID"]
   :source-type          {::m/type ::m/enum
                          ::m/vals #{"TRANSFORM" "EXTRACT"}
                          ::m/doc  "Job type"}
   :target               [::m/string ::m/nilable "Third party service data (e.g. webhook URL, email, etc.)"]
   :target-type          [::m/string "Type of third party service (e.g. Slack, MS Teams, etc.)"]
   :job-name             [::m/string ::m/nilable "Job name"]
   :use-account-slack    [::m/bool ::m/nilable "Use account-wide Slack webhook"]
   :use-account-ms-teams [::m/bool ::m/nilable "Use account-wide MS Teams webhook"]})


(defmodel account-notifications
  {:slack-preference    [::m/bool]
   :ms-teams-preference [::m/bool]}
  {:singleton true})